import styled from 'styled-components';

export const CompetitionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: left;
  ${props => props.theme.mediaQueries.tablet_big_down}{
    align-items: center;
  }
  & > div:last-child {
    border-bottom-width: ${props => (props.isHighlight ? '1px' : '0px')};;
  }
  ${process.env.REACT_APP_SITE === 'corriere' && `
    &.moto2, &.moto3, &.uefa-super-cup { 
      .competition-title-row-arrow, .competition-title-row-last, .competition-title-top-right {
       display: none;
      }
      .competition-title-top-left {
        pointer-events: none;
        cursor: default !important;
      }
    }
  `}
  &.uefa-super-cup { 
      .competition-title-row-arrow, .competition-title-row-last, .competition-title-top-right {
       display: none;
      }
      .competition-title-top-left {
        pointer-events: none;
        cursor: default !important;
      }
    }
`;

export const CompetitionSpace = styled.span`
  width: 100%;
  height: 20px;
`;
